export const SEARCH_FORMAT_DATE = 'MM/dd/yyyy';
export const SERVER_FORMAT_DATE = 'yyyy-MM-dd';
export const ITERABLE_FORMAT_DATE = 'yyyy-MM-dd HH:mm:ss XXX';

export const WORKING_START_OF_DAY = 9;
export const WORKING_END_OF_DAY = 17;
export const WORKING_HOURS = '9AM-5PM CST';
export const WORKING_TIMEZONE = 'America/Chicago';
